<template>
  <div class="container">
    
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <stats-card
          :title="(CaAnnonceur!=null) ? Math.floor(CaAnnonceur.statsCaJG_Lead[0].ca + CaAnnonceur.statsCaJG_Click[0].ca).toLocaleString() + ' €' : '0 €'"
          :loading='$apollo.queries.CaAnnonceur.loading'
          :sub-title="$t('Pages.dashboard.ExpensesGlobalDay')"
          type="primary"
          icon="tim-icons icon-coins"
        >
        </stats-card>
      </div>
      <div class="col-lg-6 col-md-12">
        <stats-card
          :title="(CaAnnonceur!=null) ? Math.floor(CaAnnonceur.statsCaMG_Lead[0].ca + CaAnnonceur.statsCaMG_Click[0].ca).toLocaleString() + ' €' : '0 €'"
          :loading='$apollo.queries.CaAnnonceur.loading'
          :sub-title="$t('Pages.dashboard.ExpensesGlobalMonth')"
          type="primary"
          icon="tim-icons icon-single-02"
        >
        </stats-card>
      </div>
    </div>

    <!-- Small charts -->
    <div class="row">
      <div class="col-lg-6" :class="{ 'text-right': isRTL }">
        <div class="card card-chart" data="blue">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-3 text-left">
                <h5 class="card-category" style="color:#fff">WEEDO</h5>
                <h2 class="card-title">PERF</h2>
              </div>
              <div class="col-sm-3 text-center" style="border:3px solid #fff; margin:0 0 10px 0; border-radius:10px; background:#5B4A82">
                LEADS DU JOUR <br>
                <base-button 
                  v-if="$apollo.queries.statLeadsOfDay.loading"
                  loading type="default">
                </base-button>
                <span style="font-size:1.5em">{{ statLeadsOfDay }}</span>
              </div>
              <div class="col-sm-6">
                <div class="btn-group btn-group-toggle float-right" data-toggle="buttons">
                  <label
                    style="font-size: 0.75rem"
                    v-for="(option, index) in bigLineChartCategories"
                    :key="option.name"
                    class="btn btn-sm btn-default btn-simple"
                    :class="{ active: bigLineChart.activeIndex === index }"
                    :id="index"
                  >
                    <input
                      type="radio"
                      @click="initBigChart(index)"
                      name="options"
                      autocomplete="off"
                      :checked="bigLineChart.activeIndex === index"
                    />
                    <span class="d-none d-sm-block">{{ option.name }}</span>
                    <span class="d-block d-sm-none">
                      <el-tooltip
                        :content="option.name"
                        effect="light"
                        :open-delay="300"
                        placement="top"
                      >
                        <i :class="option.icon"></i>
                      </el-tooltip>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <base-button 
              v-if="$apollo.queries.statsCaWeek.loading || $apollo.queries.statShootOfWeek.loading || $apollo.queries.statLeadsOfWeek.loading" 
              style="position: absolute;top: 60%;
                left: 50%;
                -moz-transform: translateX(-50%) translateY(-50%);
                -webkit-transform: translateX(-50%) translateY(-50%);
                transform: translateX(-50%) translateY(-50%);" 
              loading type="default">
            </base-button>
            <div class="chart-area">
              <line-chart
                v-if="!$apollo.queries.statsCaWeek.loading && !$apollo.queries.statShootOfWeek.loading && !$apollo.queries.statLeadsOfWeek.loading"
                style="height: 100%"
                ref="bigChart"
                :chart-data="bigLineChart.chartData"
                :gradient-colors="bigLineChart.gradientColors"
                :gradient-stops="bigLineChart.gradientStops"
                :extra-options="bigLineChart.extraOptions"
              >
              </line-chart>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card card-chart" data="red" v-if="id_clien_leadmarket">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-3 text-left">
                <h5 class="card-category" style="color:#fff">WEEDO</h5>
                <h2 class="card-title">MARKET</h2>
              </div>
              <div class="col-sm-3 text-center" style="color: white;border:3px solid #fff; margin:0 0 10px 0; border-radius:10px; background:#3f4ba3">
                LEADS DU JOUR<br>
                <base-button 
                  v-if="$apollo.queries.getLeadOfDay.loading"
                  loading type="default">
                </base-button>
                <span v-else style="font-size:1.5em">{{(getLeadOfDay!=null) ? (getLeadOfDay.leads).toLocaleString() : 0}}</span>
              </div>
              <div class="col-sm-6">
                <div class="btn-group btn-group-toggle float-right" data-toggle="buttons">
                  <label
                    style="font-size: 0.75rem"
                    v-for="(option, index) in bigLineChartCategories2"
                    :key="option.name"
                    class="btn btn-sm btn-default btn-simple"
                    :class="{ active: bigLineChartLeadMarket.activeIndex === index }"
                    :id="index"
                  >
                    <input
                      type="radio"
                      @click="initBigChartMarket(index)"
                      name="options"
                      autocomplete="off"
                      :checked="bigLineChartLeadMarket.activeIndex === index"
                    />
                    <span class="d-none d-sm-block">{{ option.name }}</span>
                    <span class="d-block d-sm-none">
                      <i :class="option.icon"></i>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <base-button 
              v-if="$apollo.queries.getCAAndLeadsAnnonceur.loading" 
              style="position: absolute;top: 60%;
                left: 50%;
                -moz-transform: translateX(-50%) translateY(-50%);
                -webkit-transform: translateX(-50%) translateY(-50%);
                transform: translateX(-50%) translateY(-50%);" 
              loading type="default">
            </base-button>
            <div class="chart-area">
              <line-chart
                v-if="!$apollo.queries.getCAAndLeadsAnnonceur.loading" 
                style="height: 100%"
                :chart-data="bigLineChartLeadMarket.chartData"
                :gradient-stops="bigLineChartLeadMarket.gradientStops"
                :extra-options="bigLineChartLeadMarket.extraOptions"
              >
              </line-chart>
            </div>
          </div>
        </div>
        <div class="card card-chart" :data="Offer_Weekend_WM.color" v-else>
          <div class="card-body text-center" style="background: none">
            <img :src="Offer_Weekend_WM.img"  width="460" height="250">
            <a class="btn btn-warning mt-4 pull-right " :href="Offer_Weekend_WM.link" target="_blank">{{ Offer_Weekend_WM.btnText }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">      
      <div class="col-lg-6" v-if="id_clien_leadmarket">
        <div class="card card-chart">
          <carousel-3d id="carousel3d_dashboard" style="margin: 0" :autoplay="true" :autoplay-timeout="5000" :perspective="0" :controls-visible="true" :width="540" :height="335" :display="1">
            <slide v-for="(slide, i) in slides" :index="i" :key="i">
                <template v-if="i == 0">
                  <div class="card card-chart" style="width: 100%; height: 100%;">
                    <VedioPresentation />
                  </div>
                </template>
                <div class="card card-chart" :data="Offer_Weekend_WM.color" v-else>
                  <div class="card-body text-center" style="background: none">
                    <img :src="Offer_Weekend_WM.img"  width="460" height="250">
                    <a class="btn btn-warning mt-4 pull-right " :href="Offer_Weekend_WM.link" target="_blank">{{ Offer_Weekend_WM.btnText }}</a>
                  </div>
                </div>
            </slide>
          </carousel-3d>
        </div>
      </div>
      <div class="col-lg-6" v-else>
        <div class="card card-chart" style="padding:0" >
          <div class="card-body mx-auto" style="background: none; margin: 0; padding:0">
            <VedioPresentation />
          </div>
        </div>
      </div>

      
      <div class="col-lg-6">
        <div class="card card-chart">
          <carousel-3d id="carousel3d_dashboard" style="margin: 0" :autoplay="true" :autoplay-timeout="5000" :perspective="0" :controls-visible="true" :width="540" :height="335" :display="1">
          <slide v-for="(offer, i) in Offers_an" :index="i" :key="i">
            <template v-if="offer.link == 'list program'">
              <div class="card-body" >
                <div class="row">
                  <div class="col text-left">
                    <router-link style="color: darkgrey;" :to="{ name: 'liste programmes My Affil Annonceur' }">MES DERNIÈRES CAMPAGNES</router-link>
                  </div>
                </div>
                <el-table height='270' :data="listAnnonces" v-loading="$apollo.queries.listAnnonces.loading" row-class-name="booking-table-rows">
                  <el-table-column
                    min-width="55"
                  >
                    <template scope="scope">
                      <div class="prog mr-2 float-left">
                        <img
                          v-if="scope.row.hostname != 'plf'"
                          :src="'https://www.weedoit.fr/tracking/partenaire/' + scope.row.repertoire + '/profil-S.png'"
                          @error="imageLoadError"
                          style="cursor: pointer;"
                        />
                        <img
                          v-else
                          :src="'https://weedoit-media.s3.eu-central-1.amazonaws.com/programme/' + scope.row.repertoire + '/profil-S.png'"
                          @error="imageLoadError"
                          style="cursor: pointer;"
                        />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="Titre"
                    label="Campagne"
                    min-width="160"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="categorie"
                    label="CATÉGORIE"
                    min-width="115"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column 
                    prop label="Action" 
                    class="table-striped" 
                    min-width="100">
                    <template scope="scope">
                      <el-tooltip
                          :content="$t('buttons.BtnView').toUpperCase()"
                          effect="light"
                          :open-delay="300"
                          placement="top"
                        >
                          <base-button
                            @click.native="Visualiser(scope.row)"
                            class="like btn-link"
                            type="info"
                            size="sm"
                            icon
                          >
                            <i class="tim-icons icon-tv-2"></i>
                          </base-button>
                        </el-tooltip>
                    </template>
                  </el-table-column>

                </el-table>
              </div>
            </template>
            <template v-else>
              <div class="card card-chart" :data="offer.color" style="width: 100%; height: 100%;">
                <div class="card-body text-center" style="background: none">
                  <img :src="offer.img"  width="460" height="250">
                  <a class="btn btn-default mt-4 pull-right" :href="offer.link" target="_blank">{{ offer.btnText }}</a>
                </div>
              </div>
            </template>
          </slide>
          </carousel-3d>
        </div>
      </div> 

    </div>
  </div>
</template>
<script>
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';
import * as chartConfigs from '@/components/Charts/config';
import StatsCard from 'src/components/Cards/StatsCard';
import config from '@/config';
import gql from 'graphql-tag'
import { Table, TableColumn } from 'element-ui';
import { Carousel3d, Slide } from "vue-carousel-3d";
import VedioPresentation from './LayoutAnnonceur/VedioPresentation'
import { Offers, Offer_Weekend_WM } from "./Offers-an";


let Mounth = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Aout",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre"
]

let bigChartDataMarket = [
  [],
  []
]

let bigChartData = [
  [],
  [],
  []
]

let bigChartLabels = ['LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM', 'DIM']
let bigChartLabelsMarket = ['LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM', 'DIM']

let bigChartDatasetOptions = {
  fill: true,
  borderColor: config.colors.myAfill,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.myAfill,
  pointBorderColor: 'rgba(255,255,255,0)',
  pointHoverBackgroundColor: config.colors.myAfill,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
}
let bigChartDatasetOptionsMarket = {
  fill: true,
  borderColor: config.colors.WeedoMarket,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.WeedoMarket,
  pointBorderColor: 'rgba(255,255,255,0)',
  pointHoverBackgroundColor: config.colors.WeedoMarket,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
}
export default {
  apollo: {
    getCAAndLeadsAnnonceur: {
      client: 'MARKET',
      query: require("src/graphql/leadmarket/Annonceur/getCAAndLeadsAnnonceur.gql"),
      fetchPolicy: 'network-only',
      result({ data, loader, networkStatus }) {
        
        bigChartLabelsMarket = this.setChartLabels()

        for (let i = 0; i < data.getCAAndLeadsAnnonceur.length; i++) {
          bigChartDataMarket[0][i] = data.getCAAndLeadsAnnonceur[i].ca
          bigChartDataMarket[1][i] = data.getCAAndLeadsAnnonceur[i].leads
        }

        this.initBigChartMarket(1)
      },
      variables () {
        return {
          id_utilisateur: JSON.parse(localStorage.getItem('utilisateur')).id,
          dateType: 'w'
        }
      }
    },
    getLeadOfDay: {
      client: 'MARKET',
      query: require("src/graphql/leadmarket/Annonceur/GlobalLeadsAnnonceur.gql"),
      variables () {
        return {
          dateType: 'd',
          id_utilisateur: JSON.parse(localStorage.getItem('utilisateur')).id
        }
      },
      update: data => data.getCollectLeadsNetsAnnonceurByPeriode,
    },
    CaAnnonceur: {
      query: require("src/graphql/CaAnnonceur.gql"),
      variables () {
        return {
          id_client: this.id_client,
        }
      },
      fetchPolicy: 'network-only',
      skip() {
        return this.id_client === 0
      },
      update: data => data
    },
    statsCaJG_Lead: { 
      query: gql`query ($id_client: Int!) {
        statsCaJG_Lead (droit: "an",id_client: $id_client) {
          ca
          marge
        }
      }`,
      variables () {
        return {
          id_client: this.id_client,
        }
      },
      update: data => data.statsCaJG_Lead
    },
    statLeadsOfDay: { 
      query: gql`query ($id_client: Int!) {
        statLeadsOfDay (droit: "an",id_client: $id_client) {
          leads
          day
        }
      }`,
      variables () {
        return {
          id_client: this.id_client,
        }
      },
      update: data => (data.statLeadsOfDay) ? data.statLeadsOfDay[0].leads : 0
    },
    statsCaJG_Click: {
      query: gql`query ($id_client: Int!) {
        statsCaJG_Click (droit: "an",id_client: $id_client) {
          ca
          marge
        }
      }`,
      variables () {
        return {
          id_client: this.id_client,
        }
      }
    },
    statsCaWeek: { 
      query: gql`query ($id_client: Int!) {
        statsCaWeek_Click (droit: "an",id_client: $id_client) {
          ca
        },
        statsCaWeek_Lead (droit: "an",id_client: $id_client) {
          ca
        }
      }`,
      variables () {
        return {
          id_client: this.id_client,
        }
      },
      update: data => data,
      result({ data, loader, networkStatus }) {
        for (let i = 0; i <  this.statsCaWeek.statsCaWeek_Lead.length; i++) {
          if(this.statsCaWeek.statsCaWeek_Lead[i].ca == null && this.statsCaWeek.statsCaWeek_Click[i].ca == null)
            bigChartData[0][i] = null
          else
            bigChartData[0][i] = (this.statsCaWeek.statsCaWeek_Lead[i].ca + this.statsCaWeek.statsCaWeek_Click[i].ca).toFixed(2)
        }
        bigChartLabels = this.setChartLabels()
        this.initBigChart(2);
      },
      error(error, vm, key, type, options) {
        bigChartData[0][0] = 0
        bigChartLabels = this.setChartLabels()
        this.initBigChart(2);
      }
    },
    statShootOfWeek: { 
      query: gql` query ($id_client: Int!){
        statShootOfWeek (droit:"an",id_client: $id_client){
          day
          shoots
        }
      }`,
      variables () {
        return {
          id_client: this.id_client,
        }
      },
      result({ data, loader, networkStatus }) {
        this.statShootOfWeek.map(function(value, key) {
          bigChartData[1][key] = value.shoots
        });
      },
      error(error, vm, key, type, options) {
        bigChartData[1][0] = 0
      }
    },
    statLeadsOfWeek: {
      query: gql` query ($id_client: Int!){
        statLeadsOfWeek (droit:"an", id_client: $id_client){
          day
          leads
        }
      }`,
      variables () {
        return {
          id_client: this.id_client,
        }
      },
      result({ data, loader, networkStatus }) {
        this.statLeadsOfWeek.map(function(value, key) {
          bigChartData[2][key] = (value.leads == 0) ? null : value.leads
        });
      },
      error(error, vm, key, type, options) {
        bigChartData[2][0] = 0
      }
    },
    listAnnonces: {
      query: require("src/graphql/ListprogramWeedoPerf.gql"),
      fetchPolicy: 'network-only',
      variables() {
        return {
          id_client: JSON.parse(localStorage.getItem('utilisateur')).id_clien_myaffil,
          droit: "an",
          langue: "FR"
        }
      },
      update: data => (data.filterAnnonces) ? data.filterAnnonces.slice(0,4) : [],
    }
  },
  components: {
    LineChart,
    BarChart,
    StatsCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Carousel3d,
    Slide,
    VedioPresentation
  },
  data() {
    return {
      societe: JSON.parse(localStorage.getItem('utilisateur')).society,
      slides: 2,
      Offers_an: Offers,
      Offer_Weekend_WM: Offer_Weekend_WM, 
      id_client: JSON.parse(localStorage.getItem('utilisateur')).id_clien_myaffil,
      id_clien_leadmarket: JSON.parse(localStorage.getItem('utilisateur')).id_clien_leadmarket,
      statsCaJG_Click: null,
      statsCaWeek: null,
      statShootOfWeek: null,
      statLeadsOfWeek: null,
      statsCaJG_Lead: '',
      skipQuery: true,
      bigLineChartLeadMarket: {
        activeIndex: 1,
        chartData: {
          datasets: [{
            ...bigChartDatasetOptionsMarket,
            data: bigChartDataMarket[0]
          }],
          labels: bigChartLabelsMarket
        },
        extraOptions: {
          ...chartConfigs.purpleChartOptions,
          tooltips: {
            callbacks: {
              label: function(tooltipItems, data) {
                if(data.datasets[0].data == bigChartDataMarket[0])
                  return Math.floor(tooltipItems.yLabel).toLocaleString() + " €"
                else
                  return Math.floor(tooltipItems.yLabel).toLocaleString() + " leads"
              }
            }
          },
          scales: {
            yAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(29,140,248,0.0)',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  suggestedMax: 20,
                  suggestedMin: 0,
                  padding: 20,
                  fontColor: '#9e9e9e',
                  callback: function (value){
                    return value.toLocaleString()
                  }
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(253,93,147,0.1)',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  padding: 20,
                  fontColor: '#9e9e9e'
                }
              }
            ]
          }
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: []
      },
      bigLineChart: {
        activeIndex: 2,
        chartData: {
          datasets: [{
            ...bigChartDatasetOptions,
            data: bigChartData[0]
          }],
          labels: bigChartLabels
        },
        extraOptions: {
          ...chartConfigs.purpleChartOptions,
          tooltips: {
            callbacks: {
              label: function(tooltipItems, data) {
                if(data.datasets[0].data == bigChartData[0])
                  return Math.floor(tooltipItems.yLabel).toLocaleString() + " €"
                else if(data.datasets[0].data == bigChartData[1])
                  return Math.floor(tooltipItems.yLabel).toLocaleString() + " shoots"
                else
                  return Math.floor(tooltipItems.yLabel).toLocaleString() + " leads"
              }
            }
          },
          scales: {
            yAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(29,140,248,0.0)',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  suggestedMax: 10,
                  suggestedMin: 0,
                  padding: 20,
                  fontColor: '#9e9e9e',
                  callback: function (value){
                    return value.toLocaleString()
                  }
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(253,93,147,0.1)',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  padding: 20,
                  fontColor: '#9e9e9e'
                }
              }
            ]
          }
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: []
      },
      purpleLineChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ['LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM', 'DIM'],
          datasets: [
            {
              label: 'Data',
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: config.colors.primary,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0]
            }
          ]
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0]
      },
      greenLineChart: {
        extraOptions: chartConfigs.greenChartOptions,
        chartData: {
          labels:  ['JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          datasets: [
            {
              label: 'My First dataset',
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0]
            }
          ]
        },
        gradientColors: [
          'rgba(66,134,121,0.15)',
          'rgba(66,134,121,0.0)',
          'rgba(66,134,121,0)'
        ],
        gradientStops: [1, 0.4, 0]
      },
      blueBarChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ['USA', 'GER', 'AUS', 'UK', 'RO', 'BR'],
          datasets: [
            {
              label: 'Countries',
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [0, 0, 0, 0, 0, 0]
            }
          ]
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0]
      }
    };
  },
  computed: {
    enableRTL() {
      return this.$route.query.enableRTL;
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    bigLineChartCategories() {
      return [
        { name: 'DÉPENSES', icon: 'tim-icons icon-coins' }, 
        { name: 'SHOOTS', icon: 'tim-icons icon-spaceship' }, 
        { name: 'LEADS', icon: 'tim-icons icon-badge' }
      ];
    },
    bigLineChartCategories2() {
      return [
        { name: 'DÉPENSES', icon: 'tim-icons icon-coins' }, 
        { name: 'LEADS', icon: 'tim-icons icon-badge' }
      ];
    }
  },
  methods: {
    setChartLabels() {
      let curr = new Date
      var yesterday = new Date(curr.getTime());
      yesterday.setDate(curr.getDate() - 1);
      let week = []
      for (let i = 1; i <= 7; i++) {
        let first = yesterday.getDate() - yesterday.getDay() + i 
        let day = new Date(yesterday.setDate(first)).toISOString().slice(0, 10).split("-")
        week.push(day[2]+"/"+ Mounth[parseInt(day[1]-1)])
      }
      return week
    },
    initBigChart(index) {
      let chartData = {
        datasets: [{
          ...bigChartDatasetOptions,
          data: bigChartData[index]
        }],
        labels: bigChartLabels
      };
      // this.$refs.bigChart.updateGradients(chartData);
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    },
    Visualiser(row) {
      localStorage.setItem('ProgrammeVisualiser', JSON.stringify(row))
      this.$router.push({name: "Visualiser programme My Affil Annonceur"})
    },
    imageLoadError(event) {
      event.target.src =
        "/img/missingprofile.jpg";
    },
    initBigChartMarket(index) {
      let chartData = {
        datasets: [{
          ...bigChartDatasetOptionsMarket,
          data: bigChartDataMarket[index]
        }],
        labels: bigChartLabelsMarket
      };
      this.bigLineChartLeadMarket.chartData = chartData;
      this.bigLineChartLeadMarket.activeIndex = index;
    }
  },
  mounted() {
    if (this.$hj) {
      var userId = null;
      this.$hj('identify', userId, {
        societe: this.societe
      })
    }
    this.i18n = this.$i18n;
    if (this.enableRTL) {
      this.i18n.locale = 'ar';
      this.$rtl.enableRTL();
    }
  },
  beforeDestroy() {
    if (this.$rtl.isRTL) {
      this.i18n.locale = 'en';
      this.$rtl.disableRTL();
    }
  }
};
</script>
<style scoped>
  .prog {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto;
  }
  .prog img {
    width: 100%;
  }
</style>
<style>
  .booking-table-rows {
    text-transform: uppercase;
  }
  video {
    outline: 0px;
  }
  #carousel3d_dashboard .carousel-3d-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    background-color: #fff;
    padding: 0px;
    -webkit-transition: all 0.4s;
    transition: all 0.4s;
    border-radius: 5px;
    height: 100%; 
    width: 100%;
    padding: 0px;
    position: absolute;
    margin: 0 auto;transform-style: none !important;
    -webkit-perspective: none !important;
    -moz-perspective: none !important;
    perspective: none !important;
  }

  .carousel-3d-slide .card {
    margin-bottom: 0px;
  }
  
  .carousel-3d-controls a.prev,
  .carousel-3d-controls a.next {
    color: #fff;
  }
</style>
